import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../core/common/datePicker";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import CommonSelect from "../../core/common/commonSelect";
import type { Option } from "../../core/common/commonSelect";
import { DatePicker } from "antd";
import api from "../../api";
import nodeApi from "../../nodeApi";
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery, decryptQuery } from "../../utils/encryption";
import Table from "../../core/common/dataTable/index";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useDynamicPageSize from "../../useDynamicPageSize";
import Footer from "../../Footer";
import { useFilterData } from "../../context/FilterContext";
import "bootstrap/dist/js/bootstrap.bundle.min";
import dayjs, { Dayjs } from "dayjs";
import avtar2 from "../../assets/images/avtar2.jpeg";

const Inventory = () => {
  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();
  const { encryptedQuery } = useParams<{
    moduleName: string;
    encryptedQuery?: string;
  }>();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const pageSize = useDynamicPageSize();
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<string>("0");
  const [selectedInventoryType, setSelectedInventoryType] =
    useState<string>("0"); // or default
  const [selectedBrand, setBrand] = useState<string>("0");
  const [selectedVendor, setSelectedVendor] = useState<string>("0");
  const [selectedCondition, setSelectedCondition] = useState<string>("0");
  const [selectedStatus, setSelectedStatus] = useState<string>("0");
  const [InventoryRecords, setInventoryRecords] = useState<any[]>([]);
  const [inventoryTypes, setInventoryTypes] = useState<InventoryTypes[]>([]);
  const [brands, setBrands] = useState<Brand[]>([]);
  const [conditions, setConditions] = useState<Record<string, string>>({});
  const [statuses, setStatuses] = useState<Record<string, string>>({});
  const [users, setUsers] = useState<SimpleUser[]>([]);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const { filtersData } = useFilterData();
  const [errors, setErrors] = useState<{ [key in keyof FormData]?: string }>(
    {}
  );
  const [attendanceErrorMessage, setAttendanceErrorMessage] = useState("");
  const [editId, setEditId] = useState<number | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [loading, setLoading] = useState(true);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const isInitialFetch = useRef(true);
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const userInitiatedSearchRef = useRef(false);

  interface InventoryHistoryItem {
    id: number;
    inventory_id: number;
    user_id: number;
    user_name: string | null;
    alloted_date: string | null;
    released_date: string | null;
  }

  const [inventoryHistory, setInventoryHistory] = useState<InventoryHistoryItem[]>([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  useLayoutEffect(() => {
    if (pageSize === 0) return;
    const calculateHeight = () => {
      const baseOffset = 194;
      const extraOffset = window.innerWidth <= 991 ? -43 : -81;
      const fixedOffset = baseOffset + extraOffset;

      const newHeight = window.innerHeight - fixedOffset;

      console.log("Calculated table height:", newHeight);
      console.log("fixedOffset:", fixedOffset);
      console.log("window.innerHeight:", window.innerHeight);
      console.log("pagesize:", pageSize);
      console.log("totalItems", totalItems);

      setTableHeight(newHeight);
    };

    calculateHeight(); // initial + on totalItems change
    window.addEventListener("resize", calculateHeight);

    return () => window.removeEventListener("resize", calculateHeight);
  }, [totalItems, pageSize]);
  const handleAdd = () => {
    setIsEditMode(false);
    console.log("Add button clicked");
    // Reset the form data
    setFormData({
      inventoryType: "",
      description: "",
      brand: "",
      configuration: "",
      condition: "",
      purchaseDate: null,
      purchaseFrom: "",
      invoiceNo: "",
      allottedTo: "",
      warranty: "",
      status: "",
      deviceCode: "",
      images: [],
    });
    //  Reset placeholders with 6 empty placeholders
    setPlaceholders(Array(6).fill({ imageUrl: "", imageFile: undefined }));

    // Reset selected images too
    setSelectedImages([]);
    // Reset error messages
    setErrors({});

    const modalElement = document.getElementById("inventory-modal");
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  };
  interface Image {
    id?: number; // for existing images
    imageFile?: File; // for new images
    imageUrl?: string; // for preview of existing images
  }

  interface FormData {
    inventoryType: string;
    description: string;
    brand: string;
    configuration: string;
    condition: string;
    purchaseDate: Dayjs | null;
    purchaseFrom: string;
    invoiceNo: string;
    allottedTo: string;
    warranty: string;
    status: string;
    deviceCode: string;
    images: Image[]; // Define images as an array of Image objects
  }
  const [formData, setFormData] = useState<FormData>({
    inventoryType: "",
    description: "",
    brand: "",
    configuration: "",
    condition: "",
    purchaseDate: null,
    purchaseFrom: "",
    invoiceNo: "",
    allottedTo: "",
    warranty: "",
    status: "",
    deviceCode: "",
    images: [], // Initialize images as an empty array of Image objects
  });
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [localInput, setLocalInput] = useState("");
  const [placeholders, setPlaceholders] = useState(
    Array(6).fill({ imageUrl: avtar2, imageFile: null })
  );
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedImages, setSelectedImages] = useState<File[]>([]);

  const userOptions: Option[] = [
    { label: "Not Alloted", value: "0.5" },
    ...users
      .filter((user) => String(user.id) !== "0")
      .map((user) => ({
        label: user.name,
        value: String(user.id),
      })),
  ];

  const inventoryTypeOptions: Option[] = [
    { label: "All Type", value: "0" },
    ...inventoryTypes.map((type) => ({
      label: type.name,
      value: String(type.id),
    })),
  ];

  const brandOptions: Option[] = [
    { label: "All Brand", value: "0" },
    ...brands.map((brand) => ({
      label: brand.name,
      value: String(brand.id),
    })),
  ];

  const vendorOptions: Option[] = [
    { label: "All Vendor", value: "0" },
    ...vendors.map((vendor) => ({
      label: vendor.name,
      value: String(vendor.id),
    })),
  ];

  const conditionOptions = [
    { label: "Condition", value: "0" },
    ...Object.entries(conditions).map(([key, value]) => ({
      label: value,
      value: key,
    })),
  ];

  const statusOptions = [
    { label: "All Status", value: "0" },
    ...Object.entries(statuses).map(([key, value]) => ({
      label: value,
      value: key,
    })),
  ];
  interface ImagePlaceholder {
    imageUrl: string;
    imageFile?: File; // Only for newly uploaded
    id?: number; // Only for existing (from API)
  }

  const handleImages = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    const maxFiles = 6;

    // Keep existing placeholders (including ones from API)
    const newPlaceholders = [...placeholders];
    const newSelectedImages: File[] = [...selectedImages];

    let placeholderIndex = 0;
    let fileIndex = 0;

    while (placeholderIndex < maxFiles && fileIndex < files.length) {
      const placeholder = newPlaceholders[placeholderIndex];

      // Replace placeholder only if it's empty or contains a default image
      if (!placeholder?.imageFile && !placeholder?.id) {
        const file = files[fileIndex];
        newPlaceholders[placeholderIndex] = {
          imageUrl: URL.createObjectURL(file),
          imageFile: file,
          id: null,
        };
        newSelectedImages.push(file);
        fileIndex++;
      }

      placeholderIndex++;
    }

    // Ensure max 6 images
    const finalPlaceholders = newPlaceholders.slice(0, maxFiles);

    setPlaceholders(finalPlaceholders);
    setSelectedImages(newSelectedImages);

    // Combine existing images (with ID) and new ones for formData
    setFormData((prev) => ({
      ...prev,
      images: finalPlaceholders.map((item) =>
        item.imageFile
          ? { imageFile: item.imageFile }
          : { imageUrl: item.imageUrl, id: item.id }
      ),
    }));

    // Reset input
    if (fileInputRef.current) {
      const dataTransfer = new DataTransfer();
      files.slice(0, maxFiles).forEach((file) => dataTransfer.items.add(file));
      fileInputRef.current.files = dataTransfer.files;
    }
  };

  const handleDeleteImage = async (index: number) => {
    const imageToDelete = placeholders[index];
    const payload = imageToDelete.id;
    // If the image has an ID, call API to delete from backend
    if (imageToDelete.id) {
      try {
        await api(`/remove-inventory-image`, {
          method: "POST",
          body: { image_id: payload },
        });
      } catch (err) {
        console.error("Failed to delete image from server:", err);
        return; // Don't delete from UI if backend delete fails
      }
    }

    // Remove from UI
    const updatedPlaceholders = [...placeholders];
    const removedFile = updatedPlaceholders[index].imageFile;

    updatedPlaceholders[index] = {
      imageUrl: "", // Or avtar2 if you want default image
      imageFile: undefined,
      id: null, // Ensure it's reset
    };

    setSelectedImages((prev) => prev.filter((file) => file !== removedFile));
    setPlaceholders(updatedPlaceholders);

    // Also update images in formData
    setFormData((prev) => ({
      ...prev,
      images: updatedPlaceholders.map((item) =>
        item.imageFile
          ? { imageFile: item.imageFile }
          : { imageUrl: item.imageUrl, id: item.id }
      ),
    }));

    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    document.body.classList.add("custom-table-padding");
    return () => {
      document.body.classList.remove("custom-table-padding");
    };
  }, []);

  // useEffect(() => {
  //   console.log("pageSize for Inventory:", pageSize);
  // }, []);

  //   useEffect(() => {
  //     fetchInventoryFilters();
  //   }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); // debounce time

    return () => clearTimeout(handler);
  }, [searchTerm]); // triggers when user types

  useEffect(() => {
    if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchInventory(debouncedSearchTerm);
  }, [
    debouncedSearchTerm,
    selectedBrand,
    selectedInventoryType,
    selectedUserId,
    selectedCondition,
    selectedVendor,
    selectedStatus,
    currentPage,
    pageSize,
  ]);
  //   useEffect(() => {
  // 	 if (isInitialFetch.current) {
  //       isInitialFetch.current = false;
  //       return;
  //     }
  //     const handler = setTimeout(() => {
  //       // fetchInventory();
  //     }, 300);
  //     console.log("handler function called");
  //     return () => clearTimeout(handler);
  //   }, [
  //     // searchTerm,
  //     selectedBrand,
  //     selectedInventoryType,
  //     selectedUserId,
  //     selectedCondition,
  //     selectedVendor,
  //     selectedStatus,
  //     currentPage,
  //     pageSize
  //   ]);

  interface InventoryEditItem {
    id: number;
    type: number;
    description: string;
    device_code: string;
    brand: number;
    configuration: string;
    condition: number;
    date_of_purchase: string;
    purchased_from: number;
    invoice_no: string;
    Alloted_to: number;
    warranty: string;
    status: number;
    created_at: string;
    updated_at: string;
    inventory_images: any[]; // You can replace `any` with a more specific type if you have it
  }

  interface InventoryiDetailsResponse {
    success: boolean;
    message: string;
    data: InventoryEditItem;
  }

  const handleEdit = async (id: number) => {
    setIsEditMode(true);
    setEditId(id);
    try {
      const response: InventoryiDetailsResponse = await api(
        `/edit-inventory/${id}`,
        {
          method: "GET",
        }
      );
      const result = await response.data;
      if (result) {
        setFormData({
          inventoryType: String(result.type) ?? "",
          description: result.description ?? "",
          brand: String(result.brand) ?? "",
          configuration: result.configuration ?? "",
          condition: String(result.condition) ?? "",
          purchaseDate: result.date_of_purchase
            ? dayjs(result.date_of_purchase, "YYYY-MM-DD")
            : null,
          purchaseFrom: String(result.purchased_from) ?? "",
          invoiceNo: result.invoice_no ?? "",
          allottedTo:
            String(result.Alloted_to) === "" ||
            result.Alloted_to == null ||
            Number(result.Alloted_to) === 0
              ? "0.5"
              : String(result.Alloted_to),
          warranty: result.warranty ?? "",
          status: String(result.status) ?? "",
          deviceCode: result.device_code ?? "",
          images: result.inventory_images ?? [],
        });
        // Prepare image placeholders padded to 6
        const existingImages = (result.inventory_images ?? []).map(
          (img: any) => ({
            imageUrl: img.inventory_image,
            imageFile: undefined,
            id: img.id, // optional, for delete tracking
          })
        );

        const paddedPlaceholders = [...existingImages];
        while (paddedPlaceholders.length < 6) {
          paddedPlaceholders.push({
            imageUrl: "",
            imageFile: undefined,
            id: null,
          });
        }

        setPlaceholders(paddedPlaceholders);
        // Reset error messages
        setErrors({});

        // Show the modal after setting the form data
        const modalElement = document.getElementById("inventory-modal");
        if (modalElement) {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
        }
      } else {
        console.error("Failed to fetch inventory data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching inventory data:", error);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await api<{ success: boolean; error?: string }>(
        `/delete-inventory/${id}`,
        { method: "DELETE" }
      );
      if (res.success) {
        setTotalItems((prevCount) => prevCount - 1);
        toast.success("Inventory deleted successfully!");
        // Calculate the total pages after deletion
        const totalPages = Math.ceil((totalItems - 1) / pageSize);
        // If the current page number is now greater than totalPages, move back one page
        if (currentPage > totalPages) {
          setCurrentPage(totalPages > 0 ? totalPages : 1);
          updateFilterUrl({
              searchTerm,
              selectedInventoryType,
              selectedUserId,
              selectedBrand,
              selectedVendor,
              selectedCondition,
              selectedStatus,
              currentPage: totalPages > 0 ? totalPages : 1,
            });
        } else {
          await fetchInventory(searchTerm);
        }
      } else {
        toast.error(res.error || "Failed to delete Inventory.");
      }
    } catch (err: any) {
      toast.error(err.message || "Something went wrong.");
      console.error("Delete error:", err.message);
    }
  };

  const openDeleteModal = (id: number) => {
    setDeleteId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };

  const handleViewHistory = async (inventoryId: number) => {
    try {
      setIsLoadingHistory(true);
      const data = await nodeApi<{ history: InventoryHistoryItem[] }>(
        `/inventory-history/${inventoryId}`
      );

      if (data && data.history && data.history.length > 0) {
        setInventoryHistory(data.history);
      } else {
        setInventoryHistory([]);
        toast.info("No history found for this inventory item.");
      }
      const modalElement = document.getElementById("inventory-history-modal");
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    } catch (err: any) {
      const backendMessage = err?.response?.data?.message;
      console.error("Error fetching inventory history:", backendMessage);
      toast.error(backendMessage || "Failed to fetch inventory history");
    } finally {
      setIsLoadingHistory(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "inventory_type",
      minWidth: 230,
      maxWidth: 230,
      render: (text: string, record: InventoryItem) => {
        const maxNameLength = 20;
        const maxDesignationLength = 25;

        const truncateText = (
          text: string | undefined,
          maxLength: number
        ): string =>
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text || "";
        return (
          <div className="d-flex align-items-center file-name-icon">
            <div className="avatar avatar-md border avatar-rounded">
              <img
                src={
                  record.inventory_type?.image_icon ||
                  "assets/img/users/default.jpg"
                }
                className="img-fluid"
                alt="img"
              />
            </div>
            <div className="ms-2">
              <h6 className="fw-medium" title={record.inventory_type?.name}>
                <Link to="#">
                  {truncateText(record.inventory_type?.name, maxNameLength)}
                </Link>
              </h6>
              <span
                className="fs-12 fw-normal"
                title={String(record.device_code)}
              >
                {truncateText(String(record.device_code), maxDesignationLength)}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Brand",
      dataIndex: "brand",
      minWidth: 60,
      maxWidth: 60,
      render: (_: any, record: InventoryItem) => {
        const brandName = record.inventory_brand?.name || "-";
        return brandName;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      minWidth: 60,
      maxWidth: 60,
      render: (_: any, record: InventoryItem) => {
        const description = record.description || "-";
        return description;
      },
    },
    {
    title: "Configuration",
    dataIndex: "configuration",
    minWidth: 60,
    maxWidth: 60,
    render: (_: any, record: InventoryItem) => {
      return record.configuration || "-";
    },
  },
  {
    title: "Vendor",
    dataIndex: "purchased_from",
    minWidth: 100,
    maxWidth: 100,
    render: (_: any, record: InventoryItem) => {
      const vendor = vendorOptions.find(
        (option) => option.value === String(record.purchased_from)
      );
      return vendor?.label || "-";
    },
  },
    {
      title: "Alloted To",
      dataIndex: "alloted_to",
      minWidth: 100,
      maxWidth: 100,
      render: (_: any, record: InventoryItem) => {
        const alloted_to = record.user?.name || "-";
        return alloted_to;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      minWidth: 100,
      maxWidth: 100,
      render: (_: any, record: InventoryItem) => {
        const status = record.status_name || "-";
        return status;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      minWidth: 90,
      maxWidth: 90,
      render: (_text: string, record: InventoryItem) => (
        <div className="action-icon d-inline-flex">
          <Link to="#" onClick={() => handleEdit(record.id)}>
            <i className="ti ti-edit" />
          </Link>
          <Link to="#" onClick={() => openDeleteModal(record.id)}>
            <i className="ti ti-trash" />
          </Link>
          <Link to="#" onClick={() => handleViewHistory(record.id)}>
            <i className="ti ti-eye" title="View History" />
          </Link>
        </div>
      ),
    },
  ];

  interface InventoryFilterParams {
    searchTerm: string;
    selectedInventoryType: string;
    selectedUserId: string;
    selectedBrand: string;
    selectedVendor: string;
    selectedCondition?: string;
    selectedStatus?: string;
    currentPage?: number;
  }

  const defaultInventoryFilters: InventoryFilterParams = {
    searchTerm: "",
    selectedInventoryType: "0",
    selectedUserId: "0",
    selectedBrand: "0",
    selectedVendor: "0",
    selectedCondition: "0",
    selectedStatus: "0",
    currentPage: 1,
  };

  const areInventoryFiltersDefault = (filters: InventoryFilterParams) => {
    return (
      (filters.searchTerm ?? "") === defaultInventoryFilters.searchTerm &&
      filters.selectedInventoryType ===
        defaultInventoryFilters.selectedInventoryType &&
      filters.selectedUserId === defaultInventoryFilters.selectedUserId &&
      filters.selectedBrand === defaultInventoryFilters.selectedBrand &&
      filters.selectedVendor === defaultInventoryFilters.selectedVendor &&
      (filters.selectedCondition ?? "") ===
        defaultInventoryFilters.selectedCondition &&
      (filters.selectedStatus ?? "") ===
        defaultInventoryFilters.selectedStatus &&
      (filters.currentPage ?? 1) === defaultInventoryFilters.currentPage
    );
  };

  useEffect(() => {
    console.log("encrypted function called");
    if (encryptedQuery) {
      try {
        const decoded = decodeURIComponent(encryptedQuery);
        const result = decryptQuery(decoded);

        if (result && typeof result === "object") {
          const data = result as InventoryFilterParams;
          setSelectedUserId(data.selectedUserId ?? "0");
          setSelectedInventoryType(data.selectedInventoryType ?? "");
          setBrand(data.selectedBrand);
          setSelectedVendor(data.selectedVendor);
          setCurrentPage(data.currentPage ?? 1);
          setSelectedCondition(data.selectedCondition ?? "");
          setSelectedStatus(data.selectedStatus ?? "");
          return;
        }
      } catch (e) {
        console.warn("Failed to decrypt attendance query:", e);
      }
    }
  }, [encryptedQuery]);

  const updateFilterUrl = (
    filters: InventoryFilterParams,
    baseRoute: string = "/inventory"
  ) => {
    console.log("Updating URL with filters:", filters);
    if (areInventoryFiltersDefault(filters)) {
      console.log("Filters are default — resetting to base route.");
      navigate(baseRoute, { replace: false });
    } else {
      const encrypted = encryptQuery(filters);
      const encoded = encodeURIComponent(encrypted);
      console.log("Filters are NOT default — updating with:", encoded);
      navigate(`${baseRoute}/${encoded}`, { replace: false });
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    updateFilterUrl({
      searchTerm,
      selectedInventoryType,
      selectedUserId,
      selectedBrand,
      selectedVendor,
      selectedCondition,
      selectedStatus,
      currentPage: page,
    });
  };

  interface InventoryItem {
    id: number;
    type: number;
    description: string;
    device_code: number;
    brand: number;
    configuration: string;
    purchased_from: number;
    status_name: string;
    total_paid: number;
    inventory_type: {
      id?: number;
      name?: string;
      image_icon?: string;
    };
    inventory_brand: {
      id?: number;
      name?: string;
    };
    user: {
      id?: number;
      name?: string;
    };
  }
  interface InventoryTypes {
    id: number;
    name: string;
    image_icon: string;
  }
  interface Brand {
    id: number;
    name: string;
  }
  interface PaginationLink {
    url: string | null;
    label: string;
    active: boolean;
  }
  interface InventoryPagination {
    current_page: number;
    data: InventoryItem[];
    first_page_url?: string;
    from?: number;
    last_page?: number;
    last_page_url?: string;
    links?: PaginationLink[];
    next_page_url?: string | null;
    path?: string;
    per_page?: number;
    prev_page_url?: string | null;
    to?: number;
    total?: number;
  }
  interface SimpleUser {
    id: number;
    name: string;
    image_url: string;
  }
  interface Vendor {
    id: number;
    name: string;
  }
  type InventoryApiResponse = {
    success?: boolean;
    current_page?: number;
    total_pages?: number;
    total_records?: number;
    inventory?: InventoryPagination;
  };
  interface InventoryFiltersApiResponse {
    inventoryTypes?: InventoryTypes[];
    brand?: Brand[];
    condition?: Record<string, string>;
    status?: Record<string, string>;
    vendors?: Vendor[];
    user?: SimpleUser[];
  }

  useEffect(() => {
    if (filtersData && Object.keys(filtersData).length > 0) {
      if (filtersData.inventoryTypes)
        setInventoryTypes(filtersData.inventoryTypes);
      if (filtersData.brand) setBrands(filtersData.brand);
      if (filtersData.condition) setConditions(filtersData.condition);
      if (filtersData.status) setStatuses(filtersData.status);
      if (filtersData.user) setUsers(filtersData.user);
      if (filtersData.vendors) setVendors(filtersData.vendors);
    }
  }, [filtersData]);

  const fetchInventory = async (searchTerm: string = "") => {
    const normalizeValue = (val: string | null | undefined): string =>
      val === "0" || val == null ? "" : val;

    const normalizedUserId = Number(normalizeValue(selectedUserId));
    const searchEmployee =
      normalizedUserId === 0
        ? ""
        : normalizedUserId === 0.5
        ? "0"
        : normalizedUserId;

    const payload = {
      brand: normalizeValue(selectedBrand),
      condition: normalizeValue(selectedCondition),
      searchEmployee,
      searchTerm: searchTerm || "",
      status: normalizeValue(selectedStatus),
      type: normalizeValue(selectedInventoryType),
      vendor: normalizeValue(selectedVendor),
      currentPage,
      pageSize,
    };

    try {
      setLoading(true);
      const response: InventoryApiResponse = await api("/filter-inventory", {
        method: "POST",
        body: payload,
      });

      const records = response.inventory?.data || [];
      setInventoryRecords(records);
      setTotalItems(response.total_records || 0);
    } catch (err) {
      console.error(
        "Failed to fetch inventory:",
        err instanceof Error ? err.message : err
      );
    } finally {
      setLoading(false);
    }
  };

  //   const fetchInventoryFilters = async () => {
  //     const payload = {
  //       pageTitle: "inventory"
  //     };
  //     try {
  //       const response: InventoryFiltersApiResponse = await api("/get-filters-data", {
  //         method: "POST",
  //         body: payload,
  //       });
  //       // Set data directly as per response structure
  //       if (response.inventoryTypes) setInventoryTypes(response.inventoryTypes);
  //       if (response.brand) setBrands(response.brand);
  //       if (response.condition) setConditions(response.condition);
  //       if (response.status) setStatuses(response.status);
  //       if (response.user) setUsers(response.user);
  //       if (response.vendors) setVendors(response.vendors);
  //     } catch (err) {
  //       if (err instanceof Error) {
  //         console.error("Failed to fetch attendance:", err.message);
  //       } else {
  //         console.error("Unknown error while fetching attendance");
  //       }
  //     } finally {
  //     }
  //   };

  type InventoryImage = {
    imageFile?: File;
    imageUrl?: string;
    id?: number;
  };

  const handleSubmit = async () => {
    const requiredFields: (keyof FormData)[] = [
      "inventoryType",
      "description",
      "brand",
      "configuration",
      "condition",
      "purchaseDate",
      "purchaseFrom",
      "invoiceNo",
      "warranty",
      "status",
      "deviceCode",
    ];
    // Checking for required fields
    let newErrors: { [key in keyof FormData]?: string } = {};
    let hasError = false;

    for (let field of requiredFields) {
      if (!formData[field] || formData[field] === "0") {
        newErrors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required`;
        hasError = true;
      }
    }
    setErrors(newErrors);
    if (hasError) return;

    const formPayload = new FormData();
    formPayload.append("type", formData.inventoryType);
    formPayload.append("description", formData.description);
    formPayload.append("brand", formData.brand);
    formPayload.append("configuration", formData.configuration);
    formPayload.append("condition", formData.condition);
    // Convert the Moment to YYYY-MM-DD
    const dateString = formData.purchaseDate
      ? formData.purchaseDate.format("YYYY-MM-DD")
      : "";
    formPayload.append("date_of_purchase", dateString);
    formPayload.append("purchased_from", formData.purchaseFrom);
    formPayload.append("invoice_no", formData.invoiceNo);
    formPayload.append(
      "alloted_to",
      formData.allottedTo === "0.5" ? "" : formData.allottedTo
    );
    formPayload.append("warranty", formData.warranty);
    formPayload.append("status", formData.status);
    formPayload.append("device_code", formData.deviceCode);

    //  Append ID for update mode
    if (isEditMode && editId !== null) {
      formPayload.append("id", editId.toString());
    }

    //  Append image files
    (formData.images as InventoryImage[]).forEach((imgObj, index) => {
      if (imgObj.imageFile) {
        formPayload.append("images[]", imgObj.imageFile);
      }
    });

    type SaveInventoryApiResponse = {
      success: boolean;
      message: string;
    };
    try {
      const response: SaveInventoryApiResponse = await api("/save-inventory", {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data", // Explicitly set content type
        },
        body: formPayload, // Ensure the data is sent as JSON if required
      });

      // Log the response status and statusText for debugging
      console.log("Response Status:", response);
      console.log("Response Status Text:", response.success);

      // Parse the JSON data
      const data = await response;
      if (response.success) {
        if (isEditMode) {
          await fetchInventory(searchTerm);
        } else {
          // For add mode:
          setTotalItems((prevCount) => prevCount + 1);
          setCurrentPage(1);
          updateFilterUrl({
            searchTerm,
            selectedInventoryType,
            selectedUserId,
            selectedBrand,
            selectedVendor,
            selectedCondition,
            selectedStatus,
            currentPage: 1,
          });
          await fetchInventory(searchTerm);
        }
        const closeBtn = document.getElementById(
          "close-modal"
        ) as HTMLButtonElement;
        if (closeBtn) {
          closeBtn.click(); // Simulate a click to trigger data-bs-dismiss
        }
        toast.success(
          isEditMode
            ? "Inventory updated successfully!"
            : "Inventory added successfully!"
        );
      } else {
         const msg = response.message?.toLowerCase().includes('duplicate')
      ? 'Duplicate Inventory! Inventory already exists.'
      : response.message || 'Failed to save Inventory.';
    toast.error(msg);
      }
    } catch (err: any) {
        if (err.response && err.response.data) {
    const errorData = err.response.data;
    const msg = errorData.message?.toLowerCase().includes('duplicate')
      ? 'Duplicate Inventory! Inventory already exists.'
      : errorData.message || 'Failed to save Inventory.';
    toast.error(msg);
  } else {
    toast.error(err.message || 'Something went wrong.');
  }
  }   
} 

  const handleReset = () => {
    setSelectedUserId("0");
    setSelectedCondition("0");
    setBrand("0");
    setSelectedVendor("0");
    setSelectedInventoryType("0");
    setSelectedStatus("0");
    setCurrentPage(1);
    setSearchTerm("");
    setLocalInput("");
    navigate(`/inventory`, { replace: false });
  };

  const handleUserChange = (
    selected: { value: string; label: string } | null
  ) => {
    const value = selected?.value ?? "0";
    setSelectedUserId(value);

    updateFilterUrl({
      searchTerm,
      selectedUserId: value,
      selectedInventoryType,
      selectedBrand,
      selectedVendor,
      selectedCondition,
      selectedStatus,
      currentPage: 1,
    });
  };
  const handleInventoryTypeChange = (
    selected: { value: string; label: string } | null
  ) => {
    const value = selected?.value ?? "0";
    setSelectedInventoryType(value);

    updateFilterUrl({
      searchTerm,
      selectedUserId,
      selectedInventoryType: value,
      selectedBrand,
      selectedVendor,
      selectedCondition,
      selectedStatus,
      currentPage: 1,
    });
  };
  const handleBrandChange = (
    selected: { value: string; label: string } | null
  ) => {
    const value = selected?.value ?? "0";
    setBrand(value);
    updateFilterUrl({
      searchTerm,
      selectedUserId,
      selectedInventoryType,
      selectedBrand: value,
      selectedVendor,
      selectedCondition,
      selectedStatus,
      currentPage: 1,
    });
  };
  const handleConditionChange = (
    selected: { value: string; label: string } | null
  ) => {
    const value = selected?.value ?? "0";
    setSelectedCondition(value);
    updateFilterUrl({
      searchTerm,
      selectedUserId,
      selectedInventoryType,
      selectedBrand,
      selectedVendor,
      selectedCondition: value,
      selectedStatus,
      currentPage: 1,
    });
  };
  const handleStatusChange = (
    selected: { value: string; label: string } | null
  ) => {
    const value = selected?.value ?? "0";
    setSelectedStatus(value);
    updateFilterUrl({
      searchTerm,
      selectedUserId,
      selectedInventoryType,
      selectedBrand,
      selectedVendor,
      selectedCondition,
      selectedStatus: value,
      currentPage: 1,
    });
  };
  const handleVendorChange = (
    selected: { value: string; label: string } | null
  ) => {
    const value = selected?.value ?? "0";
    setSelectedVendor(value);
    updateFilterUrl({
      searchTerm,
      selectedUserId,
      selectedInventoryType,
      selectedBrand,
      selectedVendor: value,
      selectedCondition,
      selectedStatus,
      currentPage: 1,
    });
  };

  useEffect(() => {
    console.log("handle rezise called");
    const handleResize = () => setIsMobile(window.innerWidth < 1586);
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const commonFilters = (
    <>
      <CommonSelect
        isFullWidth={true}
        isOpenModal={true}
        className={`select w-100 ${isMobile ? "mb-2" : ""}`}
        options={userOptions}
        value={userOptions.find(
          (o) => String(o.value) === String(selectedUserId)
        )}
        onChange={handleUserChange}
      />
      <CommonSelect
        isFullWidth={true}
        isOpenModal={true}
        className={`select w-100 ${isMobile ? "mb-2" : ""}`}
        options={inventoryTypeOptions}
        value={inventoryTypeOptions.find(
          (o) => String(o.value) === String(selectedInventoryType)
        )}
        onChange={handleInventoryTypeChange}
      />
      <CommonSelect
        isFullWidth={true}
        isOpenModal={true}
        className={`select w-100 ${isMobile ? "mb-2" : ""}`}
        options={brandOptions}
        value={brandOptions.find(
          (o) => String(o.value) === String(selectedBrand)
        )}
        onChange={handleBrandChange}
      />
      <CommonSelect
        isFullWidth={true}
        isOpenModal={true}
        className={`select w-100 ${isMobile ? "mb-2" : ""}`}
        options={conditionOptions}
        value={conditionOptions.find(
          (o) => String(o.value) === String(selectedCondition)
        )}
        onChange={handleConditionChange}
      />
      <CommonSelect
        isFullWidth={true}
        isOpenModal={true}
        className={`select w-100 ${isMobile ? "mb-2" : ""}`}
        options={vendorOptions}
        value={vendorOptions.find(
          (o) => String(o.value) === String(selectedVendor)
        )}
        onChange={handleVendorChange}
      />
      <CommonSelect
        isFullWidth={true}
        isOpenModal={true}
        className={`select w-100 ${isMobile ? "mb-2" : ""}`}
        options={statusOptions}
        value={statusOptions.find(
          (o) => String(o.value) === String(selectedStatus)
        )}
        onChange={handleStatusChange}
      />
    </>
  );

  const handleDateChange = (
    date: dayjs.Dayjs | null,
    field: keyof FormData
  ) => {
    setFormData({ ...formData, [field]: date });
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setLocalInput(val);
    setSearchTerm(val);
    setCurrentPage(1);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      const trimmed = val.trim();

      if (trimmed.length < 1) {
        navigate("/inventory", { replace: true });
        return;
      }

      updateFilterUrl({
        searchTerm: trimmed,
        currentPage: 1,
        selectedInventoryType,
        selectedUserId,
        selectedBrand,
        selectedVendor,
        selectedCondition,
        selectedStatus,
      });
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  interface FiltersProps {
    searchTerm: string;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleReset: () => void;
    handleAdd: () => void;
    commonFilters: React.ReactNode;
  }

  const FiltersDesktop: React.FC<FiltersProps> = ({
    searchTerm,
    onSearchChange,
    handleReset,
    handleAdd,
    commonFilters,
  }) => {
    const [localInput, setLocalInput] = useState(searchTerm);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
    // Debounce effect: delays the setting of debouncedSearchTerm after 500ms
    useEffect(() => {
      const timer = setTimeout(() => {
        setDebouncedSearchTerm(localInput);
      }, 500); // 500ms delay after the user stops typing

      // Cleanup the timeout if searchTerm changes before 500ms
      return () => clearTimeout(timer);
    }, [localInput]);

    // API call or search action triggered when debouncedSearchTerm changes
    //   useEffect(() => {
    // 	 if (isInitialFetch.current) {
    //       isInitialFetch.current = false;
    //       return;
    //     }
    //     console.log("Debounced search term:", debouncedSearchTerm);
    //     // Call your API or filter function here
    //     // fetchInventory(debouncedSearchTerm);
    //   }, [debouncedSearchTerm]);
    const isResetVisible =
      (selectedUserId && String(selectedUserId) !== "0") ||
      (selectedInventoryType && String(selectedInventoryType) !== "0") ||
      (selectedBrand && String(selectedBrand) !== "0") ||
      (selectedCondition && String(selectedCondition) !== "0") ||
      (selectedVendor && String(selectedVendor) !== "0") ||
      (selectedStatus && String(selectedStatus) !== "0") ||
      (searchTerm && searchTerm !== "") ||
      localInput !== "";
    return (
      <div className="px-2 px-md-2">
        <div className="attendance-filters d-flex align-items-center flex-wrap">
          <div className="d-flex align-items-center gap-2">
            {isResetVisible && (
              <button
                className="btn add_btn_size btn-outline-primary att-reset"
                onClick={() => {
                  setLocalInput("");
                  handleReset();
                }}
                title="Reset"
              >
                <i className="ti ti-refresh" />
              </button>
            )}
            <input
              type="text"
              className="form-control search-size"
              placeholder="Search…"
              value={localInput}
              onChange={(e) => {
                setLocalInput(e.target.value);
                onSearchChange(e); // still keep parent in sync if needed
              }}
            />
            {commonFilters}
            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={handleAdd}
            >
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const FiltersMobile: React.FC<FiltersProps> = ({
    searchTerm,
    onSearchChange,
    handleReset,
    handleAdd,
    commonFilters,
  }) => {
    const [localInput, setLocalInput] = useState(searchTerm);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      console.log("handle click out side called");
      const handleClickOutside = (event: MouseEvent) => {
        if (
          modalRef.current &&
          !modalRef.current.contains(event.target as Node)
        ) {
          setShowModal(false);
        }
      };
      if (showModal) document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [showModal]);

    useEffect(() => {
      const timer = setTimeout(() => {
        setDebouncedSearchTerm(localInput);
      }, 500);

      return () => clearTimeout(timer);
    }, [localInput]);

    //   useEffect(() => {
    // 	 if (isInitialFetch.current) {
    //       isInitialFetch.current = false;
    //       return;
    //     }
    //     fetchInventory(debouncedSearchTerm);
    //   }, [debouncedSearchTerm]);

    const isResetVisible =
      (selectedUserId && String(selectedUserId) !== "0") ||
      (selectedInventoryType && String(selectedInventoryType) !== "0") ||
      (selectedBrand && String(selectedBrand) !== "0") ||
      (selectedCondition && String(selectedCondition) !== "0") ||
      (selectedVendor && String(selectedVendor) !== "0") ||
      (selectedStatus && String(selectedStatus) !== "0") ||
      (searchTerm && searchTerm !== "") ||
      localInput !== "";
    return (
      <div className="upper-absolute-class">
        <div className="attendance-filters-mobile d-flex align-items-center gap-2 inventory-margin-right">
          {isResetVisible && (
            <button
              className="btn add_btn_size btn-outline-primary"
              onClick={() => {
                setLocalInput("");
                handleReset();
              }}
              title="Reset"
            >
              <i className="ti ti-refresh" />
            </button>
          )}
          <div className="holiday-flex">
            <input
              type="text"
              className="form-control search-size"
              placeholder="Search…"
              value={localInput}
              onChange={(e) => {
                setLocalInput(e.target.value);
                onSearchChange(e); // still keep parent in sync if needed
              }}
            />
          </div>
          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={() => setShowModal(true)}
          >
            <i className="ti ti-filter" />
          </button>
          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={handleAdd}
          >
            <i className="ti ti-circle-plus" />
          </button>
        </div>

        {showModal && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "103px",
              zIndex: 1050,
            }}
          >
            <div
              ref={modalRef}
              className="bg-white p-3 rounded shadow"
              style={{ width: "90%", maxWidth: "400px" }}
            >
              {commonFilters}
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    console.log("filter function called");
    setFilters(
      isMobile ? (
        <FiltersMobile
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          handleReset={handleReset}
          handleAdd={handleAdd}
          commonFilters={commonFilters}
        />
      ) : (
        <FiltersDesktop
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          handleReset={handleReset}
          handleAdd={handleAdd}
          commonFilters={commonFilters}
        />
      )
    );
    return () => setFilters(null);
  }, [
    isMobile,
    setFilters,
    users,
    selectedUserId,
    selectedInventoryType,
    selectedBrand,
    selectedCondition,
    selectedVendor,
    selectedStatus,
    // searchTerm
  ]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper d-flex flex-column">
        <div className="content flex-grow-1">
          {/* Table Section */}
          <div className="card card-margin-bottom">
            <div
              className="card-body p-0"
              style={{
                height: tableHeight,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Table
                style={{ flex: 1 }}
                dataSource={InventoryRecords}
                columns={columns}
                totalItems={totalItems}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </div>
        </div>
        {/* Add/Edit Inventory Modal */}
        <div id="inventory-modal" className="modal fade" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  {isEditMode ? "Edit Inventory" : "Add Inventory"}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-4 mb-3 w-full">
                    <label>
                      Type <span className="text-danger">*</span>
                    </label>
                    <CommonSelect
                      placeholder="Select Inventory Type"
                      isFullWidth={true}
                      isOpenModal={true}
                      className={`select w-100 ${isMobile ? "mb-2" : ""}`}
                      options={inventoryTypeOptions}
                      value={inventoryTypeOptions.find(
                        (o) => String(o.value) === formData.inventoryType
                      )}
                      onChange={(selected) => {
                        setFormData({
                          ...formData,
                          inventoryType: String(selected?.value ?? "0"),
                        });
                      }}
                      forceFullWidth={true}
                    />
                    {errors.inventoryType && (
                      <small className="text-danger">
                        {errors.inventoryType}
                      </small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Description <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.description} // Bind description to formData
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          description: e.target.value,
                        })
                      }
                    />
                    {errors.description && (
                      <small className="text-danger">
                        {errors.description}
                      </small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3 w-full">
                    <label>
                      Brand <span className="text-danger">*</span>
                    </label>
                    <CommonSelect
                      placeholder="Select Brand"
                      isFullWidth={true}
                      isOpenModal={true}
                      className={`select w-100 ${isMobile ? "mb-2" : ""}`}
                      options={brandOptions}
                      value={brandOptions.find(
                        (o) => o.value === formData.brand
                      )}
                      onChange={(selected) =>
                        setFormData({
                          ...formData,
                          brand: selected?.value ?? "0",
                        })
                      }
                      forceFullWidth={true}
                    />
                    {errors.brand && (
                      <small className="text-danger">{errors.brand}</small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Configuration <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.configuration} // Bind configuration to formData
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          configuration: e.target.value,
                        })
                      }
                    />
                    {errors.configuration && (
                      <small className="text-danger">
                        {errors.configuration}
                      </small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3 w-full">
                    <label>
                      Condition <span className="text-danger">*</span>
                    </label>
                    <CommonSelect
                      placeholder="Select Condition"
                      isFullWidth={true}
                      isOpenModal={true}
                      className={`select w-100 ${isMobile ? "mb-2" : ""}`}
                      options={conditionOptions}
                      value={conditionOptions.find(
                        (o) => o.value === formData.condition
                      )}
                      onChange={(selected) =>
                        setFormData({
                          ...formData,
                          condition: selected?.value ?? "0",
                        })
                      }
                      forceFullWidth={true}
                    />
                    {errors.condition && (
                      <small className="text-danger">{errors.condition}</small>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Date of Purchase <span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-end position-relative">
                      <DatePicker
                        className="form-control datetimepicker ps-15"
                        value={
                          formData.purchaseDate
                            ? dayjs(formData.purchaseDate, "DD-MMM-YYYY")
                            : null
                        } // Use dayjs for parsing
                        onChange={(date) =>
                          handleDateChange(date, "purchaseDate")
                        }
                        format="DD-MMM-YYYY"
                        placeholder="DD-MMM-YYYY"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                    {errors.purchaseDate && (
                      <small className="text-danger">
                        {errors.purchaseDate}
                      </small>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3 w-full">
                    <label>
                      Purchase From <span className="text-danger">*</span>
                    </label>
                    <CommonSelect
                      placeholder="Select Vendor"
                      isFullWidth={true}
                      isOpenModal={true}
                      className={`select w-100 ${isMobile ? "mb-2" : ""}`}
                      options={vendorOptions}
                      value={vendorOptions.find(
                        (o) => o.value === formData.purchaseFrom
                      )}
                      onChange={(selected) =>
                        setFormData({
                          ...formData,
                          purchaseFrom: selected?.value ?? "0",
                        })
                      }
                      forceFullWidth={true}
                    />
                    {errors.purchaseFrom && (
                      <small className="text-danger">
                        {errors.purchaseFrom}
                      </small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Invoice No <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.invoiceNo} // Bind invoiceNo to formData
                      onChange={(e) =>
                        setFormData({ ...formData, invoiceNo: e.target.value })
                      }
                    />
                    {errors.invoiceNo && (
                      <small className="text-danger">{errors.invoiceNo}</small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3 w-full ">
                    <label>Alloted To</label>
                    <CommonSelect
                      isFullWidth={true}
                      isOpenModal={true}
                      className={`select w-100 ${isMobile ? "mb-2" : ""}`}
                      options={userOptions}
                      value={
                        formData.allottedTo
                          ? userOptions.find(
                              (o) => o.value === formData.allottedTo
                            )
                          : userOptions.find((o) => o.value === "0.5")
                      }
                      onChange={(selected) =>
                        setFormData({
                          ...formData,
                          allottedTo: selected?.value ?? "0.5",
                        })
                      }
                      forceFullWidth={true}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Warranty <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.warranty} // Bind warranty to formData
                      onChange={(e) =>
                        setFormData({ ...formData, warranty: e.target.value })
                      }
                    />
                    {errors.warranty && (
                      <small className="text-danger">{errors.warranty}</small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3 w-full">
                    <label>
                      Status <span className="text-danger">*</span>
                    </label>
                    <CommonSelect
                      isFullWidth={true}
                      isOpenModal={true}
                      className={`select w-100 ${isMobile ? "mb-2" : ""}`}
                      options={statusOptions}
                      value={statusOptions.find(
                        (o) => o.value === formData.status
                      )}
                      onChange={(selected) =>
                        setFormData({
                          ...formData,
                          status: selected?.value ?? "0",
                        })
                      }
                      forceFullWidth={true}
                      placeholder="Select status"
                    />
                    {errors.status && (
                      <small className="text-danger">{errors.status}</small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3 ">
                    <label>
                      Device Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.deviceCode} // Bind deviceCode to formData
                      onChange={(e) =>
                        setFormData({ ...formData, deviceCode: e.target.value })
                      }
                    />
                    {errors.deviceCode && (
                      <small className="text-danger">{errors.deviceCode}</small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>Images </label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      multiple
                      onChange={handleImages}
                      ref={fileInputRef}
                    />
                  </div>

                  <div className="row mt-3 d-flex">
                    {placeholders.map((image, index) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="image-placeholder">
                          {image.imageFile || image.imageUrl ? (
                            <div style={{ position: "relative" }}>
                              <img
                                src={
                                  image.imageFile
                                    ? image.imageUrl
                                    : image.imageUrl
                                }
                                alt={`placeholder-${index}`}
                                style={{
                                  width: "100%",
                                  height: "200px",
                                  objectFit: "contain",
                                  border: "4px solid rgb(243, 240, 240)",
                                  borderRadius: "8px",
                                }}
                              />
                              <button
                                className="delete-btn"
                                type="button"
                                onClick={() => handleDeleteImage(index)}
                                style={{
                                  position: "absolute",
                                  top: "-3px",
                                  right: "3px",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  color: "#ff0000",
                                  fontSize: "20px",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fa fa-times" />
                              </button>
                            </div>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "8px",
                                border: "4px solid rgb(243, 240, 240)",
                              }}
                            >
                              <img
                                src={avtar2}
                                alt={`default-placeholder-${index}`}
                                style={{
                                  width: "60%",
                                  height: "60%",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  id="close-modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  {isEditMode ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Delete Confirmation Modal */}
        <div id="top-modal" className="modal fade">
          <div className="modal-dialog modal-top">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Delete Inventory</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-cancel" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => deleteId !== null && handleDelete(deleteId)}
                  data-bs-dismiss="modal"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Inventory History Modal */}
        <div
          id="inventory-history-modal"
          className="modal fade"
          tabIndex={-1}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Inventory History</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <div className="modal-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>User</th>
                        <th>Allotted Date</th>
                        <th>Released Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingHistory ? (
                        <tr>
                          <td colSpan={3} className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : inventoryHistory.length > 0 ? (
                        <>
                          {inventoryHistory.map((item) => (
                            <tr key={item.id}>
                              <td>{item.user_name || "-"}</td>
                              <td>
                                {item.alloted_date
                                  ? dayjs(item.alloted_date).format("DD-MMM-YYYY hh:mm A")
                                  : "-"}
                              </td>
                              <td>
                                {item.released_date
                                  ? dayjs(item.released_date).format("DD-MMM-YYYY hh:mm A")
                                  : "-"}
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            No history available for this inventory item.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div>
          <Footer />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Inventory;
